<template>
  <div id="app">
    <div class="header">
      <div class="ptb27">月账单统计</div>
      <div>
        <img
          class="loginOutImg"
          :src="loginOutImg"
          alt=""
          @click="handleLoginOut"
        />
      </div>
      <!-- 筛选 -->
      <div class="header-select" @click="handleMerchantSelect">
        <div>
          <img class="permotionIcon" :src="permotionIcon" alt="" />
        </div>
        <div class="header-select-title" v-if="promotionCodes.length === 0">
          {{ permotionTitle }}
        </div>
        <div class="header-select-title2" v-else>
          已选推广码+ {{ promotionCodes.length }}
        </div>
        <div>
          <img class="rightIcon pt8" :src="rightIcon" alt="" />
        </div>
      </div>
      <!-- 结算合计 -->
      <div class="settlement-total">
        <div class="settlement-total-date" @click="show = true">
          <div class="cur">{{ timeStr }}</div>
          <div>
            <img class="timeIcon" :src="timeIcon" alt="" />
          </div>
        </div>
        <div class="total-settled-amount" v-if="settlementStatus === 'settled'">
          已结算合计
        </div>
        <div
          class="total-settled-amount"
          v-if="settlementStatus === 'unsettled'"
        >
          未结算合计
        </div>
        <div class="bill-details">
          <div class="bill-details-left">{{ total }}笔</div>
          <!-- <div class="bill-details-right cur" @click="ToBillDetails">
            账单明细
          </div> -->
        </div>
      </div>
    </div>
    <!-- 订单构成 -->
    <div class="orderDetail">订单构成</div>
    <div class="orderCard" v-for="(item, index) in list" :key="index">
      <div
        class="orderItem"
        v-for="it in item.details"
        :key="it.id"
        @click="handleOrderItem(it)"
      >
        <div class="df">
          <div>
            <img
              class="smallIcon"
              :src="svipIcon"
              alt=""
              v-if="item.productType === 'base'"
            />
            <img
              class="smallIcon"
              :src="vipIcon"
              alt=""
              v-if="item.productType === 'china_base'"
            />
            <img
              class="smallIcon"
              :src="lixianIcon"
              alt=""
              v-if="item.productType === 'offline'"
            />
            <img
              class="smallIcon"
              :src="yinshipinIcon"
              alt=""
              v-if="item.productType === 'video'"
            />
          </div>
          <div>{{ it.productName }}</div>
        </div>
        <div class="df">
          <div>{{ it.count }}笔</div>
          <div>
            <img class="rightIcon pt2 pl8" :src="rightIcon" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="list && list.length === 0">
      <van-empty description="暂无数据" />
    </div>
    <!-- tabbar -->
    <van-tabbar v-model="active" @change="onChange">
      <van-tabbar-item icon="home-o">
        <span>主页</span>
        <template #icon="props">
          <img :src="props.active ? icon1.active : icon1.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon2.active : icon2.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <!-- 选择日期 -->
    <van-popup
      v-model="show"
      round
      closeable
      position="bottom"
      :style="{ height: '60%' }"
      :close-on-click-overlay="false"
    >
      <div class="p16">
        <div class="date-title">选择日期</div>
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择日期"
          :min-date="minDate"
          :formatter="formatter"
          :show-toolbar="false"
          @change="handleDatetimePicker"
        />
        <div class="date-submit" @click="handleDatetimePickerOk">确定</div>
      </div>
    </van-popup>
    <!-- 选择推广码 -->
    <van-popup
      v-model="show2"
      round
      closeable
      position="bottom"
      :style="{ height: '60%' }"
      :close-on-click-overlay="false"
      @click-close-icon="handleClose"
    >
      <div class="p16">
        <div class="date-title">选择推广码</div>
        <div class="promotions">
          <div class="products">
            <div
              v-for="item in list2"
              :key="item.code"
              :class="{
                'products-item': true,
                'products-item-active': item.checked,
              }"
              @click="handleProductItem2(item)"
            >
              {{ item.code }}
            </div>
          </div>
        </div>
        <div class="date-submit" @click="handlePromotionsOk">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { getCommisionSummary, getPromotionCodes } from "@/api/home";
export default {
  data () {
    return {
      ids: [],
      permotionTitle: "全部推广码",
      timeStr: "",
      timeStr2: "",
      icon1: {
        active: require("../assets/home2.png"),
        inactive: require("../assets/home1.png"),
      },
      icon2: {
        active: require("../assets/mine2.png"),
        inactive: require("../assets/mine1.png"),
      },
      active: 0,
      show: false,
      show2: false,
      minDate: new Date(2020, 0, 1),
      currentDate: new Date(),
      loginOutImg: require("../assets/login-out.png"),
      permotionIcon: require("../assets/icon-promotion.png"),
      rightIcon: require("../assets/right-icon.png"),
      timeIcon: require("../assets/icon-time.png"),
      svipIcon: require("../assets/icon-svip.png"),
      vipIcon: require("../assets/icon-vip.png"),
      lixianIcon: require("../assets/icon-lixian.png"),
      yinshipinIcon: require("../assets/icon-yinshipin.png"),
      list3: [],
      list2: [],
      list: [],
      total: 0,
      settlementStatus: "",
      promotionCodes: []
    }
  },
  mounted () {
    localStorage.removeItem("ids")
    this.timeStr = this.timeFormatting(this.currentDate)
    this.timeStr2 = this.timeFormatting2(this.currentDate)
    this.getCommisionSummaryNet()
    this.getPromotionCodesNet()
  },
  methods: {
    handleClose () {
      this.promotionCodes = []
      this.getPromotionCodesNet()
    },
    getPromotionCodesNet () {
      getPromotionCodes().then(res => {
        if (res?.data?.items) {
          const codeArr = [
            {
              code: '全部',
              checked: true
            }
          ]
          this.list2 = [...codeArr, ...res.data.items]
          this.list2.forEach(item => {
            if (item.code !== '全部') {
              item.checked = false
            }
          })
        }
      })
    },
    getCommisionSummaryNet () {
      const params = {
        month: this.timeStr2,
      }
      if (this.promotionCodes && this.promotionCodes.length !== 0) {
        params.promotionCodes = this.promotionCodes
      }
      getCommisionSummary(params).then(res => {
        // console.log("商户佣金总览", res);
        if (res?.data) {
          this.list = res?.data?.items || []
          this.total = res.data.total
          this.settlementStatus = res.data?.settlementStatus
        }
      })
    },
    timeFormatting (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      return y + '年' + m + '月'
    },
    timeFormatting2 (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      return y + '-' + m
    },
    handleProductItem (val) {
      if (val.code === '全部') {
        this.list2.forEach(item => {
          item.checked = !item.checked
        })
        const data1 = this.list2.filter(item => item.code !== '全部')
        const result1 = data1.every(item => item.checked)
        if (result1) {
          const code1 = []
          data1.forEach(item => {
            code1.push(item.code)
          })
          this.promotionCodes = [...new Set(code1)]
        } else {
          this.promotionCodes = []
        }
        // console.log("全部----", this.promotionCodes);
      } else {
        this.list2.forEach(item => {
          if (item.code === val.code) {
            item.checked = !item.checked
          }
        })
        const data2 = this.list2.filter(item => item.code !== '全部')
        const result2 = data2.every(item => item.checked)
        const code2 = []
        if (result2) {
          this.list2.forEach(item => {
            if (item.code === '全部') {
              item.checked = true
            }
          })
          data2.forEach(item => {
            code2.push(item.code)
          })
        } else {
          this.list2.forEach(item => {
            if (item.code === '全部') {
              item.checked = false
            }
            if (item.checked) {
              code2.push(item.code)
            }
          })
        }
        this.promotionCodes = [...new Set(code2)]
        // console.log("部分", this.promotionCodes);
      }

      this.$forceUpdate()
    },
    handleProductItem2 (val) {
      if (val.code === '全部') {
        this.list2.forEach(item => {
          if (item.code === '全部') {
            item.checked = !item.checked
          } else {
            item.checked = false
          }
        })
        this.promotionCodes = []
        return
      }
      this.list2.forEach(item => {
        if (item.code === val.code) {
          item.checked = !item.checked
        }
        if (item.code === '全部') {
          item.checked = false
        }
      })
      const code2 = []
      this.list2.forEach(item => {
        if (item.checked && item.code !== '全部') {
          code2.push(item.code)
        }
      })
      this.promotionCodes = [...new Set(code2)]
      this.$forceUpdate()
    },
    onChange (index) {
      if (index === 1) {
        this.$router.push({
          path: '/MinePage'
        })
      }
    },
    handleOrderItem (val) {
      this.ids.push(val.id)
      localStorage.setItem("ids", JSON.stringify(this.ids))
      localStorage.setItem("promotionCodes", JSON.stringify(this.promotionCodes))
      this.$router.push({
        path: "/BillDetails",
        query: {
          productIds: val.productIds,
          month: this.timeStr2
        }
      })
    },
    handleMerchantSelect () {
      // console.log("全部推广码");
      this.show2 = true
    },
    handlePromotionsOk () {
      this.getCommisionSummaryNet()
      this.show2 = false
    },
    handleLoginOut () {
      Dialog.confirm({
        title: '确认退出登录吗？',
        message: '',
      })
        .then(() => {
          this.$store.dispatch("user/resetToken").then((res) => {
            console.log("res----user/resetToken", res);
          });
          localStorage.removeItem("acount");
          localStorage.removeItem("refreshToken");
          this.$router.push({
            path: '/login'
          })
        })
        .catch(() => {
          console.log('取消退出');
        });
    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    handleDatetimePicker () {
      console.log("111", this.currentDate);
    },
    handleDatetimePickerOk () {
      this.timeStr = this.timeFormatting(this.currentDate)
      this.timeStr2 = this.timeFormatting2(this.currentDate)
      this.getCommisionSummaryNet()
      this.show = false
    },
    ToBillDetails () {
      this.$router.push({
        path: "/BillDetails"
      })
    }
  }
}
</script>

<style scoped>
#app {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-bottom: 48px;
}
.df {
  display: flex;
  justify-content: center;
}
.header {
  position: relative;
  /* width: 375px; */
  width: 100%;
  height: 280px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
  background-image: url("../assets/headerBackground.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;
  box-sizing: border-box;
}
.ptb27 {
  padding: 27px 0px;
}
.loginOutImg {
  position: absolute;
  top: 28px;
  right: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.permotionIcon {
  width: 20px;
  height: 20px;
  padding-top: 6px;
  padding-right: 16px;
}
.rightIcon {
  width: 16px;
  height: 16px;
}
.timeIcon {
  width: 16px;
  height: 16px;
  padding-left: 6px;
  cursor: pointer;
}
.header-select {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border-radius: 16px;
  background: #ffffff;
  padding: 0px 16px;
  box-sizing: border-box;
  cursor: pointer;
}
.header-select-title {
  flex: 1;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
}
.header-select-title2 {
  flex: 1;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #0475fd;
}
.settlement-total {
  width: 100%;
  height: 127px;
  border-radius: 16px;
  background: #ffffff;
  padding: 0px 16px;
  box-sizing: border-box;
  margin: 16px 0px 0px;
}
.orderDetail {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #0e273b;
  margin: 16px;
}
.settlement-total-date {
  display: flex;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #0e273b;
  padding-top: 12px;
}
.cur {
  cursor: pointer;
}
.total-settled-amount {
  font-family: Source Han Sans;
  font-size: 12px;
  font-weight: 350;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #8d8d8d;
  padding-top: 16px;
  padding-bottom: 8px;
}
.bill-details {
  display: flex;
  justify-content: center;
}
.bill-details-left {
  font-family: Source Han Sans;
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #0e273b;
}
.bill-details-right {
  width: 88px;
  height: 28px;
  border-radius: 14px;
  opacity: 1;
  box-sizing: border-box;
  border: 1px solid #0475fd;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 350;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #0475fd;
  margin-top: 7px;
}
.smallIcon {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  margin-right: 8px;
}
.orderCard {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #0e273b;
  border-radius: 16px;
  opacity: 1;
  background: #ffffff;
  padding: 16px;
  margin: 16px;
}
.orderItem {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: pointer;
}
.df {
  display: flex;
}
.pt8 {
  padding-top: 8px;
}
.pt2 {
  padding-top: 2px;
}
.pl8 {
  padding-left: 8px;
}
.p16 {
  padding: 0px 16px;
}
.date-title {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #0e273b;
  z-index: 1;
  padding: 18px 0px;
}
.date-submit {
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
  background: #0475fd;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
}
.promotions {
  height: 256px;
  overflow-x: hidden;
  overflow-y: auto;
}
.products {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  text-align: center;
}
.products-item {
  min-height: 32px;
  width: calc(50% - 8px);
  border-radius: 4px;
  opacity: 1;
  background: #f5f5f5;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 30px;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #0e273b;
  cursor: pointer;
  word-wrap: break-word;
}
.products-item-active {
  font-weight: 500;
  color: #0475fd;
  background: #ffffff;
  line-height: 30px;
  box-sizing: border-box;
  border: 1px solid #0475fd;
}
</style>